/**
 * Curated free-to-use photos (Pexels licence — commercial use allowed, no attribution required)
 * mapped to each learning topic. All URLs point to Pexels CDN with compressed, web-sized variants.
 *
 * To swap a photo: replace the URL with any images.pexels.com or images.unsplash.com URL.
 * Add ?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop for consistent card sizing.
 */

const P = (id) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=800&h=320&fit=crop`;

const TOPIC_PHOTOS = {
  /* Speed, positioning, overtaking, stopping distances */
  speed_positioning: {
    url: P("29823030"),        // Scenic winter road in Norwegian landscape — Raulling
    credit: "Raulling / Pexels",
  },

  /* Pedestrians, children, cyclists, motorcyclists */
  road_users: {
    url: P("10121600"),        // Aerial view of city pedestrian crosswalk — Pexels
    credit: "Pexels",
  },

  /* Driver responsibilities, alcohol, fatigue, phone */
  responsibilities: {
    url: P("35069866"),        // View from inside car on snowy winter road — Idzzzed
    credit: "Idzzzed / Pexels",
  },

  /* Vehicle checks, tyres, lights */
  vehicle: {
    url: P("10618732"),        // Blue car on snow-covered road — Arvis Auris
    credit: "Arvis Auris / Pexels",
  },

  /* Traffic laws, fines, licence */
  laws: {
    url: P("33893298"),        // Red yield/give-way traffic sign — Jan van der Wolf
    credit: "Jan van der Wolf / Pexels",
  },

  /* Sign families — warning, forbidden, mandatory, info */
  signs: {
    url: P("12274676"),        // Road signs compilation — didsss
    credit: "didsss / Pexels",
  },

  /* Giving way — høyreregelen, vikeplikt, forkjørsvei */
  giving_way: {
    url: P("28429518"),        // Aerial Atlantic Road, Kristiansund, Norway — Tim Diercks
    credit: "Tim Diercks / Pexels",
  },
};

export default TOPIC_PHOTOS;
